/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */


import { environment as defaultEnvironment } from './environment';
export const environment = {
  production: false,
  issuer: 'https://stage.id.trimblecloud.com',
  clientRoot: 'http://localhost:4200/',
  rootURL: 'https://api-dev-bdtool.mepdevelopment.net',
  clientId: '939e6a70-3175-4391-aa71-8a7d28fb74c8',
  clientName: 'BDToolDev',
  log: true,
  flags: {
    useNewHeader: true
  }
};
